import { Box, IconButton } from "@mui/material";
import { BellIcon } from "../../icons";
import { SystemModeView } from "../SystemModeView";
import { UserStatusViewV2 } from "../UserStatusView";
import { Menu } from "@mui/icons-material";

type MainLayoutTopComponentProps = {
  open: boolean;
  openClicked?: () => void;
  showModeView?: boolean;
};
export const MainLayoutTopComponent = ({ open, openClicked, showModeView = true }: MainLayoutTopComponentProps) => {
  return (
    <Box alignItems="center" sx={{ display: "flex", alignItems: "center", gap: "2rem" }}>
      <IconButton sx={{ marginRight: "1.25rem" }} className="menu-button" onClick={openClicked}>
        <Menu sx={{ color: "rgba(255, 255, 255, 0.3)", fontSize: "1.85rem" }} />
      </IconButton>
      <div style={{ flexGrow: 1 }}></div>
      {showModeView && <SystemModeView />}
      <Box sx={{ display: "flex", gap: "2rem", alignItems: "center" }}>
        <BellIcon />
        <UserStatusViewV2 />
      </Box>
    </Box>
  );
};
